import { Renderer } from "../renderers/renderer"

export class EndRenderer extends Renderer {
  get buttons() {
    return []
  }

  get text() {
    return this.node.dataset.name
  }
}
